var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8683",
    "data-name": "Group 8683",
    transform: "translate(-755 -111)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2157",
    "data-name": "Ellipse 2157",
    cx: 45,
    cy: 45,
    r: 45,
    transform: "translate(755 111)",
    fill: "#f5f2ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Password",
    "data-name": "Iconly/Bold/Password",
    transform: "translate(783 139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Password"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Password-2",
    "data-name": "Password",
    d: "M9.633,34C3.871,34,0,29.959,0,23.943V10.058C0,4.042,3.871,0,9.633,0H24.37C30.131,0,34,4.042,34,10.058V23.943C34,29.959,30.129,34,24.369,34ZM21.985,18.275h2.26v1.874a1.275,1.275,0,1,0,2.549,0V17a1.277,1.277,0,0,0-1.274-1.275H15.842a4.423,4.423,0,1,0,0,2.549h3.591v1.874a1.275,1.275,0,0,0,2.551,0V18.275ZM9.757,17a1.874,1.874,0,1,1,1.873,1.871A1.876,1.876,0,0,1,9.757,17Z",
    fill: "#6631f7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/change-password.98a4eb0293dc6bfc004abb3bb24a45bb.svg";
export { ForwardRef as ReactComponent };